import { Agent, Property } from '../../types/property';

const getSellingAgent = (property: Property): Agent | undefined => {
  if (property.contacts?.default) {
    return {
      ...property.contacts.default,
      logo: property.contacts.default.logos,
    };
  }

  const agents = property.contacts?.all.filter((c) => !c.developer);

  if (agents?.length === 1) {
    return {
      ...agents[0],
      logo: agents[0].logos,
    };
  }

  if (property.agents?.length === 1) {
    return property.agents[0];
  }

  return undefined;
};

export const getSellingAgentColor = (property: Property): string[] => {
  const agent = getSellingAgent(property);

  if (agent?.colours && agent.enhancedBranding && !property.featuredDevelopmentContent) {
    const secondaryColor = ['#fff', '#ffffff'].includes(agent.colours.primary.toLowerCase())
      ? agent.colours.secondary
      : agent.colours.primary;

    return [agent.colours.primary, secondaryColor];
  }

  return ['', ''];
};

export default getSellingAgent;
